import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,
  Table,
  Modal,
  Box,
  FormControl,
  RadioGroup,
  Radio,
  FormLabel,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import nopdf from "../../../assets/images/imagepreview.jpg";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getISTDate } from "../../../utils/Constant";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
import api2 from "../../../utils/Url2";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "180vh",
  height: "85vh",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};


type Props = {};

const mrnTypeOption = [
  { value: 'Discarded ', label: "Discarded" },
  { value: "WireTemporing", label: "WireTemporing" },
  { value: "InWorkshop", label: "InWorkshop" },
  { value: "SimIssue", label: "SimIssue" },
  { value: "DeviceIssue", label: "DeviceIssue" },
  { value: "Other", label: "Other" },
];


const VehicleAuditEdit = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValues } = getISTDate();
  //const [Opens, setOpen] = React.useState(false);
 // const [Img, setImg] = useState("");
  const [toaster, setToaster] = useState(false);
  const [vendorData, setVendorData] = useState([]);
 // const [panOpens, setPanOpen] = React.useState(false);
  const [vendorDetail, setVendorDetail] = useState<any>();
  const [lang, setLang] = useState<Language>("en");
  const location = useLocation();
  const initialRowData = {

  };
  const [tableData, setTableData] = useState([{ ...initialRowData }]);
  //const [taxData, setTaxData] = useState([]);
  const handlePanClose1 = () => {
    setOpen(false);
  };
  const [timerCheck, setTimerCheck] = useState<NodeJS.Timeout | null>(null); // Initialize timerCheck state

  const [deviceOption, setdeviceOption] = useState([
    { value: -1, label: t("text.id") },
  ]);

  const [VnoOption, setVnoOption] = useState([
    { value: -1, label: t("text.itemMasterId") },
  ]);

  useEffect(() => {
    getdeviceData();
    getVnoData();
  }, []);

  const getdeviceData = async () => {
    const collectData = {
      "orderby": "",
      "pageNo": 0,
      "pageSize": 0,
      "intnotnullvalue1": 0,
      "userId": "",

      "str1": "",
      "str2": "",
      "str3": "",
      "str4": "",
      "str5": "",
      "intvalue1": 0,
      "intvalue2": 0,
      "intvalue3": 0,
      "intvalue4": 0,
      "intnotnullvalue2": 0,
      "intnotnullvalue3": 0,
      "date1": defaultValues,
      "date2": defaultValues,
      "date3": defaultValues,
      "date4": defaultValues,
      "dec1": 0,
      "dec2": 0,
      "dec3": 0,
      "dec4": 0,
      "flag": true,
      "data": "",
      "success": true,
      "error": "",
      "selectPerindex": 0,
      "show": true

    };
    const response = await api.post(`DeviceType/GetDeviceType`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["dtype"],
        value: data[index]["id"],
      });
    }
    setdeviceOption(arr);
  };

  const getVnoData = async (value: string = '') => {
    const collectData = {
      "itemmasterid": -1
    };
    const response = await api.post(`ItemMaster/GetItemMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["vehicleNo"],
        value: data[index]["itemMasterId"],
      });
    }
    setVnoOption(arr);
  };



  const [panOpens, setPanOpen] = React.useState(false);
  const [modalImg, setModalImg] = useState("");
  const [Opens, setOpen] = React.useState(false);
  const [Img, setImg] = useState("");
  const handlePanClose = () => {
    setPanOpen(false);
  };
  const modalOpenHandle = (event: any) => {
    setPanOpen(true);
    if (event === "imageFile") {
      setModalImg(formik.values.imageFile);
    }
  };

  // const handlePanClose1 = () => {
  //   setOpen(false);
  // };
  // const modalOpenHandle1 = (event: any) => {
  //   setOpen(true);
  //   if (event === "signatureFile") {
  //     setImg(formik.values.signatureFile);
  //   }
  // };
  const ConvertBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const base64ToByteArray = (base64: string): Uint8Array => {
    // Remove the data URL scheme if it exists
    const base64String = base64.split(",")[1];

    // Decode the Base64 string
    const binaryString = window.atob(base64String);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    // Convert binary string to Uint8Array
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes;
  };

  const uint8ArrayToBase64 = (uint8Array: Uint8Array): string => {
    let binary = "";
    const len = uint8Array.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }
    return window.btoa(binary);
  };

  const otherDocChangeHandler = async (event: any, params: string) => {
    console.log("Image file change detected");

    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileNameParts = file.name.split(".");
      const fileExtension =
        fileNameParts[fileNameParts.length - 1].toLowerCase();

      if (!fileExtension.match(/(jpg|jpeg|bmp|gif|png)$/)) {
        alert(
          "Only image files (.jpg, .jpeg, .bmp, .gif, .png) are allowed to be uploaded."
        );
        event.target.value = null;
        return;
      }

      try {
        const base64Data = (await ConvertBase64(file)) as string;
        console.log("Base64 image data:", base64Data);

        // Convert Base64 to Uint8Array
        const byteArray = base64ToByteArray(base64Data);
        console.log("🚀 ~ otherDocChangeHandler ~ byteArray:", byteArray);

        // Convert Uint8Array to base64 string
        const base64String = uint8ArrayToBase64(byteArray);
        console.log("🚀 ~ otherDocChangeHandler ~ base64String:", base64String);

        // Set value in Formik
        formik.setFieldValue(params, base64String);

        let outputCheck =
          "data:image/png;base64," + formik.values.imageFile;
        console.log(outputCheck);
      } catch (error) {
        console.error("Error converting image file to Base64:", error);
      }
    }
  };
  const formik = useFormik({
    initialValues: {
      "id": location.state.id,
      "vehicleId": location.state.vehicleId,
      "vehicleNo": location.state.vehicleNo,
      "simNo": location.state.simNo,
      "oldSimNo": location.state.oldSimNo,
      "deviceNo": location.state.deviceNo,
      "deviceType": location.state.deviceType,
      "olddeviceNo": location.state.olddeviceNo,
      "remark": location.state.remark,
      "problemType": location.state.problemType,
      "empId": location.state.empId,
      "empName": location.state.empName,
      "empMobileNo": location.state.empMobileNo,
      "serviceEngg": location.state.serviceEngg,
      "createdBy": "",
      "updatedBy": "",
      "createdOn": defaultValues,
      "updatedOn": defaultValues,
      "imageFile": location.state.imageFile,
     // file: location.state.file,
      "simType": location.state.simType,
      "replacement": location.state.replacement,
      "companyName": location.state.companyName,
      "repair": location.state.repair,
      "workType": location.state.workType,


    },

    onSubmit: async (values) => {
      // values.vendor = vendorDetail;

      const response = await api.post(`VehicleAuditInfo/AddUpdateVehicleAuditInfo`, values);
      if (response.data.status === 1) {
        setToaster(false);
        toast.success(response.data.message);
        navigate("/vehiclemanagement/vehicleauditinformation");
      } else {
        setToaster(true);
        toast.error(response.data.message);
      }
    },
  });

  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.VehicleAuditEdit")}
          </Typography>
          <Grid container justifyContent="flex-end">
            <Grid item lg={2} md={2} xs={12} marginTop={2}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>



              <Grid container spacing={2}>
                <Grid item xs={12} lg={8}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      aria-label="workType"
                      name="workType"
                      value={formik.values.workType}
                      onChange={(event) => formik.setFieldValue("workType", event.target.value)}
                    >
                      <FormControlLabel
                        value="New Installation"
                        control={<Radio color="primary" />}
                        label={t("text.NewInstallation")}
                        sx={{ marginLeft: 2 }}
                      />
                      <FormControlLabel
                        value="Updation"
                        control={<Radio color="primary" />}
                        label={t("text.Updation")}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={VnoOption}
                  fullWidth
                  size="small"
                  value={VnoOption.find(option => option.label === formik.values.vehicleNo) || null} // Set the value based on Formik
                  onChange={(event: any, newValue: any) => {
                    if (newValue && newValue.label) {
                      formik.setFieldValue("vehicleNo", newValue.label);
                    } else {
                      formik.setFieldValue("vehicleNo", "");
                    }
                  }}
                  onInputChange={(event: any, value: string) => {
                    if (value.trim() !== "" || value !== null) {
                      if (timerCheck) {
                        clearTimeout(timerCheck);
                      }

                      if (value) {
                        const checkResult = setTimeout(() => {
                          getVnoData(value);
                        }, 500);
                        setTimerCheck(checkResult);
                      }
                    }
                  }}
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.VehicleNos1")} required={false} />}
                    />
                  )}
                  popupIcon={null}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.DriverName")} required={false} />}
    variant="outlined"
    fullWidth
    size="small"
    name="empName"
    id="empName"
    placeholder={t("text.DriverName")}
    value={formik.values.empName}
    onChange={formik.handleChange}
  />
  {formik.touched.empName && formik.errors.empName ? (
    <div style={{ color: "red", margin: "5px" }}>
      {/* {formik.errors.empName} */}
    </div>
  ) : null}
</Grid>

<Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.DriverMobileNo")} required={false} />}
    variant="outlined"
    fullWidth
    size="small"
    name="empMobileNo"
    id="empMobileNo"
    placeholder={t("text.DriverMobileNo")}
    value={formik.values.empMobileNo}
    onChange={formik.handleChange}
  />
  {formik.touched.empMobileNo && formik.errors.empMobileNo ? (
    <div style={{ color: "red", margin: "5px" }}>
      {/* {formik.errors.empMobileNo} */}
    </div>
  ) : null}
</Grid>

<Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.ServiceEngg")} required={false} />}
    variant="outlined"
    fullWidth
    size="small"
    name="serviceEngg"
    id="serviceEngg"
    placeholder={t("text.ServiceEngg")}
    value={formik.values.serviceEngg}
    onChange={formik.handleChange}
  />
  {formik.touched.serviceEngg && formik.errors.serviceEngg ? (
    <div style={{ color: "red", margin: "5px" }}>
      {/* {formik.errors.serviceEngg} */}
    </div>
  ) : null}
</Grid>

<Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.SimNo")} required={false} />}
    variant="outlined"
    fullWidth
    size="small"
    name="simNo"
    id="simNo"
    placeholder={t("text.SimNo")}
    value={formik.values.simNo}
    onChange={formik.handleChange}
  />
  {formik.touched.simNo && formik.errors.simNo ? (
    <div style={{ color: "red", margin: "5px" }}>
      {/* {formik.errors.simNo} */}
    </div>
  ) : null}
</Grid>

<Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.OldSimNo")} required={false} />}
    variant="outlined"
    fullWidth
    size="small"
    name="oldSimNo"
    id="oldSimNo"
    placeholder={t("text.OldSimNo")}
    value={formik.values.oldSimNo}
    onChange={formik.handleChange}
  />
  {formik.touched.oldSimNo && formik.errors.oldSimNo ? (
    <div style={{ color: "red", margin: "5px" }}>
      {/* {formik.errors.oldSimNo} */}
    </div>
  ) : null}
</Grid>

<Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.DeviceNo")} required={false} />}
    variant="outlined"
    fullWidth
    size="small"
    name="deviceNo"
    id="deviceNo"
    placeholder={t("text.DeviceNo")}
    value={formik.values.deviceNo}
    onChange={formik.handleChange}
  />
  {formik.touched.deviceNo && formik.errors.deviceNo ? (
    <div style={{ color: "red", margin: "5px" }}>
      {/* {formik.errors.deviceNo} */}
    </div>
  ) : null}
</Grid>

<Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.OldDeviceNo")} required={false} />}
    variant="outlined"
    fullWidth
    size="small"
    name="olddeviceNo"
    id="olddeviceNo"
    placeholder={t("text.OldDeviceNo")}
    value={formik.values.olddeviceNo}
    onChange={formik.handleChange}
  />
  {formik.touched.olddeviceNo && formik.errors.olddeviceNo ? (
    <div style={{ color: "red", margin: "5px" }}>
      {/* {formik.errors.olddeviceNo} */}
    </div>
  ) : null}
</Grid>



              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={mrnTypeOption}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("problemType", newValue?.value.toString());
                  }}
                  value={formik.values.problemType}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.ProblemType")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={deviceOption}
                  fullWidth
                  size="small"
                  value={deviceOption.find(option => option.value == formik.values.deviceType) || null} // Ensure this is correct
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("deviceType", newValue?.value.toString());
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.DeviceType")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.Remark1")} required={false} />}
    variant="outlined"
    fullWidth
    size="small"
    name="remark"
    id="remark"
    placeholder={t("text.Remark1")}
    value={formik.values.remark}
    onChange={formik.handleChange}
  />
  {formik.touched.remark && formik.errors.remark ? (
    <div style={{ color: "red", margin: "5px" }}>
      {/* {formik.errors.remark} */}
    </div>
  ) : null}
</Grid>

              <Grid container spacing={2}>
                {/* Replacement Info Radio Button Row */}
                <Grid item xs={12} lg={8} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}> {/* Reduced marginBottom */}
                  <FormLabel
                    component="legend"
                    style={{ fontWeight: 'bold', marginLeft: 20, marginRight: 8 }} // Consistent left and right spacing
                  >
                    {"Replacement Info"}
                  </FormLabel>  {/* Replacement Info Label */}
                  <RadioGroup
                    row
                    aria-label="replacement-info"
                    name="replacement"
                    value={formik.values.replacement}
                    onChange={(event) => formik.setFieldValue("replacement", event.target.value)}
                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                  >
                    <FormControlLabel
                      value="Sim"
                      control={<Radio color="primary" />}
                      label={t("text.Sim")}
                      sx={{ marginLeft: 2 }}
                    />
                    <FormControlLabel
                      value="Device"
                      control={<Radio color="primary" />}
                      label={t("text.Device")}
                    />
                    <FormControlLabel
                      value="Both"
                      control={<Radio color="primary" />}
                      label={t("text.Both")}
                    />
                  </RadioGroup>
                </Grid>

                <Grid item lg={3} md={6} xs={12}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formik.values.repair}
                          onChange={formik.handleChange}
                          name="repair"
                        />
                      }
                      label={t("text.wiretemp")}
                    />
                  </FormGroup>
                </Grid>
              </Grid>

              <Grid container spacing={1} item>
                <Grid
                  xs={12}
                  md={4}
                  sm={4}
                  item
                  style={{ marginBottom: "30px", marginTop: "30px" }}
                >
                  <TextField
                    type="file"
                    inputProps={{ accept: "image/*" }}
                    InputLabelProps={{ shrink: true }}
                    label={
                      <strong style={{ color: "#000" }}>
                        {t("text.AttachedImage")}
                      </strong>
                    }
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={(e) => otherDocChangeHandler(e, "imageFile")}
                  />
                </Grid>
                <Grid xs={12} md={4} sm={4} item></Grid>

                <Grid xs={12} md={4} sm={4} item>
                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                      margin: "10px",
                    }}
                  >
                    {formik.values.imageFile == "" ? (
                      <img
                       // src={nopdf}
                        style={{
                          width: 150,
                          height: 100,
                          border: "1px solid grey",
                          borderRadius: 10,
                        }}
                      />
                    ) : (
                      <img

                        src={"data:image/png;base64," + formik.values.imageFile}
                        style={{
                          width: 150,
                          height: 100,
                          border: "1px solid grey",
                          borderRadius: 10,
                          padding: "2px",
                        }}
                      />
                    )}
                    <Typography
                      onClick={() => modalOpenHandle("imageFile")}
                      style={{
                        textDecorationColor: "blue",
                        textDecorationLine: "underline",
                        color: "blue",
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                    >
                      {t("text.Preview")}
                    </Typography>
                  </Grid>
                </Grid>
                <Modal open={panOpens} onClose={handlePanClose}>
                  <Box sx={style}>
                    {modalImg == "" ? (
                      <img
                      //  src={nopdf}
                        style={{
                          width: "170vh",
                          height: "75vh",
                        }}
                      />
                    ) : (
                      <img
                        alt="preview image"
                        src={"data:image/png;base64," + modalImg}
                        style={{
                          width: "170vh",
                          height: "75vh",
                          borderRadius: 10,
                        }}
                      />
                    )}
                  </Box>
                </Modal>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.update")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default VehicleAuditEdit;